import { Box, Button, Checkbox, FormControl, FormHelperText, Grid2, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField, Typography } from "@mui/material"
import ORLogo from '../../assets/or1.svg'
import LoginIcon from '@mui/icons-material/Login';
import { useContext, useEffect, useRef, useState } from "react";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import './login.css'
import * as Yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { useValidateLoginMutation } from "../../redux/login/login.api";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ProfileDetails } from "../../redux/common/common.slice";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import { motion } from 'framer-motion';
import { useMsal } from '@azure/msal-react';
import Microsoft from '../../assets/microsoft.png';
import Cookies from 'js-cookie';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode";
import { GoogleLogin } from '@react-oauth/google';
import GoogleIcon from '../../assets/search.png'


const Login = () => {

    const [showPassword, setShowPassword] = useState(false);

    const validationScheme = Yup.object().shape({
        email: Yup.string().email("Enter Valid Email").required("Enter the email")
            .test('Enter Valid Email', 'Enter Valid Email', (value) => {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return emailRegex.test(value);
            }),
        password: Yup.string().required("Password is required")
    })

    const resolver = yupResolver(validationScheme)

    const {
        control,
        register,
        handleSubmit,
        formState: { errors, }
    } = useForm({
        resolver,
        mode: "onChange",
        defaultValues: {
            email: null,
            password: null,
            isMobile: false

        }
    })

    const [validate] = useValidateLoginMutation()

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { Snackbar } = useContext(SnackbarContext)
    const handleClickShowPassword = () => {
        setShowPassword((show) => !show);
    }

    const { instance } = useMsal();

    const handleMicroLogin = async () => {
        if (!instance) {
            console.error("MSAL is not initialized yet");
            return;
        }

        const loginRequest = {
            scopes: ['openid', 'profile', 'email'],
        };

        try {
            const response = await instance.loginPopup(loginRequest);
            const idToken = response?.idToken
            localStorage.setItem('idToken', idToken)

            if (!idToken) {
                throw new Error('No ID token received from Microsoft');
            }

            const result = await fetch(`${window.REACT_APP_BASE_URL}socialLoginByMicroSoft`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idToken })
            })

            const data = await result.json();

            if (result.ok && data.status !== "error") {
                const { email, token, profile } = data
                await dispatch(ProfileDetails({ profile }))
                localStorage.setItem('token', token);
                localStorage.setItem('microsoft', true)
                localStorage.setItem('email', email)
                localStorage.setItem('profile', JSON.stringify(profile))

                Cookies.set('token', token, {
                    secure: false,
                    sameSite: 'strict'
                })
                Snackbar('Login Successful', 'success')
            } else if (data?.status === "error") {
                localStorage.clear();
                Cookies.remove('token')
                Snackbar(data?.message, 'error')

                setTimeout(() => {
                    const microsoftLogoutUrl = `https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=${encodeURIComponent(window.location.origin)}`;
                    window.location.href = microsoftLogoutUrl;
                }, 2000);

            } else {
                Snackbar('error', data?.message || 'Login failed');
                setTimeout(() => {
                    const microsoftLogoutUrl = `https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=${encodeURIComponent(window.location.origin)}`;
                    window.location.href = microsoftLogoutUrl;
                }, 6000);
            }

        } catch (error) {
            console.error("Failed to sign in:", error);
            Snackbar('Error occurred while sign in', 'error');
        }
    };


    const handleGoogleLoginSuccess = async (response) => {

        const idToken = response.credential
        const decode = jwtDecode(idToken)
        const email = decode.email

        try {

            const result = await fetch(`${window.REACT_APP_BASE_URL}socialLoginByGoogle`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'Application/json'
                },
                body: JSON.stringify({ idToken }),
            })

            const data = await result?.json()


            if (result.ok) {
                if (data?.status === "success") {
                    const { token, profile } = data;
                    await dispatch(ProfileDetails({ profile }))
                    localStorage.setItem('token', token);
                    localStorage.setItem('microsoft', false)
                    localStorage.setItem('email', email)
                    localStorage.setItem('profile', JSON.stringify(profile))
                    Cookies.set('token', token)
                    Snackbar('Login Successful', 'success')
                } else if (data?.status === "error") {
                    Snackbar(data?.message, 'error')
                }
            }
        } catch (error) {
            console.error('An error occurred during Google authentication:', error);
            Snackbar('Google login failed:', error);
        }
    }



    const handleGoogleLoginFailure = (response) => {
        console.error(response);
        Snackbar('Error occurred while sign in', 'error')
    }

    const onSubmit = async (data) => {
        try {
            const result = await validate(data).unwrap()

            if (result.status === 200) {
                const { token, profile: { role } } = result.response;
                localStorage?.setItem('token', token);
                localStorage.setItem('userId', result?.response?.profile?.userId)
                localStorage.setItem("commonsearchfilter", JSON.stringify({
                    dashbord: {
                        search: '',
                        clientId: [],
                        eventId: [],
                        positionId: []
                    },
                    jobPosting: {
                        positionDesc: "",
                        clientName: 0,
                        positionId: 0,
                        positionType: "",
                        priority: "",
                        status: "",
                        selectedClientName: "",
                    },
                    candidateProfiles: {
                        sortingDirection: "",
                        address: "",
                        mobileOrAlternateMobile: "",
                        technologies: "",
                        emailOrAlternateEmail: "",
                        firstNameOrLastName: "",
                        fromDate: null,
                        toDate: null,
                        sourcedBy: ''
                    },
                    clients: {
                        clientName: "",
                        address: "",
                        email: "",
                        city: "",
                        phone: "",
                        status: "",
                        selectedstatus: "",
                        fromDate: null,
                        toDate: null,
                        sortingDirection: "",
                    },
                    recruiter: {
                        id: "",
                        name: "",
                        company: "",
                        address: "",
                        status: "",
                        emailOrPhone: "",
                        sortingDirection: ""
                    },
                    admin: {
                        userName: ""
                    },
                    clientRefferal: {
                        clientName: "",
                        address: "",
                        email: "",
                        status: 0,
                        city: "",
                        phone: "",
                        fromDate: null,
                        toDate: null,
                        sortingDirection: "",
                    },
                    jobRefferals: {
                        client: "",
                        keywords: "",
                        location: "",
                        positionId: 0,
                        positionType: "",
                        priority: "",
                        status: ""
                    },
                    reportsManageEvents: {
                        clientName: "",
                        eventTypeId: [],
                        positionId: "",
                        fromDate: null,
                        toDate: null
                    },
                    clientHiringReport: {
                        clientName: "",
                        clientId:"",
                        positionStatus: "",
                        fromDate: null,
                        toDate: null
                    },
                    auditLogs: {
                        email: ""
                    },
                    addProfile: {
                        firstNameOrLastName: "",
                        emailOrAlternateEmail: "",
                        mobileOrAlternateMobile: "",
                        technologies: "",
                        address: ""
                    }
                }));

                dispatch(ProfileDetails(result.response))
                Snackbar("Login Successful", 'success')

                if (token) {
                    if (role === "admin" || role === "coordinator") {
                        navigate('/dashboard')
                    } else if (role === "recruiter") {
                        navigate('/dashboard-recruiter')
                    }
                } else {
                    Snackbar("User not found", 'error')
                }
            } else if (result?.status === "error") {
                Snackbar(result?.data[0]?.error_message, 'error');
            }
            else {
                const errorMessage = result?.data[0]?.error_code;
                if (errorMessage === "75" || errorMessage === "Invalid Credential!") {
                    Snackbar("No account found with this email. Please check your email address", 'error');
                } else if (result?.data[0]?.error_code === "73") {
                    Snackbar("Login failed. Please check your password.", 'error');
                } else if (result?.data[0]?.error_code === "50") {
                    Snackbar("Approval by admin is still pending.", 'error')
                }
            }

        } catch (err) {
            Snackbar("Network error", 'error')
        }
    }

    const handleForgotPswdNav = () => {
        navigate('/forget-password')
    }

    const handleRegisterNav = () => {
        // navigate('/candidate-register')
    }

    const handleSignupNav = () => {
        navigate('/front-page')
    }


    const CustomEyeOpen = ({ isTyping, passwordFieldRef }) => {
        const [pupilPosition, setPupilPosition] = useState({ x: 0, y: 0 });
        const eyeRef = useRef(null);

        useEffect(() => {
            const handleMouseMove = (e) => {
                if (!eyeRef.current || !passwordFieldRef.current) return;
                    console.log("isTyping" , isTyping);

                if (isTyping) {
                    console.log("isTyping" , isTyping);
                    
                    // When typing, always look at the password field (right side)
                    const fieldRect = passwordFieldRef.current.getBoundingClientRect();
                    const fieldCenterX = fieldRect.left + fieldRect.width / 2;
                    const fieldCenterY = fieldRect.top + fieldRect.height / 2;

                    const eyeRect = eyeRef.current.getBoundingClientRect();
                    const eyeCenterX = eyeRect.left + eyeRect.width / 2;
                    const eyeCenterY = eyeRect.top + eyeRect.height / 2;

                    // Calculate direction from eye to password field
                    const deltaX = fieldCenterX - eyeCenterX;
                    const deltaY = fieldCenterY - eyeCenterY;

                    // Normalize and limit movement (look towards password field)
                    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
                    const maxDistance = 100;

                    const limitedX = Math.min(3, Math.max(-3, (deltaX / Math.max(distance, maxDistance)) * 4));
                    const limitedY = Math.min(2, Math.max(-2, (deltaY / Math.max(distance, maxDistance)) * 3));

                    setPupilPosition({
                        x: limitedX,
                        y: limitedY
                    });
                } else {
                    // When not typing, follow cursor anywhere on screen
                    const eyeRect = eyeRef.current.getBoundingClientRect();
                    const eyeCenterX = eyeRect.left + eyeRect.width / 2;
                    const eyeCenterY = eyeRect.top + eyeRect.height / 2;

                    const deltaX = e.clientX - eyeCenterX;
                    const deltaY = e.clientY - eyeCenterY;

                    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
                    const maxDistance = 200;

                    const limitedX = Math.min(3, Math.max(-3, (deltaX / Math.max(distance, maxDistance)) * 4));
                    const limitedY = Math.min(2, Math.max(-2, (deltaY / Math.max(distance, maxDistance)) * 3));

                    setPupilPosition({
                        x: limitedX,
                        y: limitedY
                    });
                }
            };

            document.addEventListener('mousemove', handleMouseMove);

            return () => {
                document.removeEventListener('mousemove', handleMouseMove);
            };
        }, [isTyping]);

        return (
            <svg
                ref={eyeRef}
                width="28"
                height="28"
                viewBox="0 0 28 28"
                style={{ cursor: 'pointer' }}
            >
                {/* Eye white with almond shape */}
                <ellipse cx="14" cy="14" rx="10" ry="8" fill="white" stroke="currentColor" strokeWidth="1.5" />

                {/* Iris */}
                <circle
                    cx={14 + pupilPosition.x}
                    cy={14 + pupilPosition.y}
                    r="3.5"
                    fill="#666"
                />

                {/* Pupil */}
                <circle
                    cx={14 + pupilPosition.x}
                    cy={14 + pupilPosition.y}
                    r="1.8"
                    fill="black"
                />

                {/* Eyelid */}
                <path
                    d="M 6 12 Q 14 9 22 12"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    fill="none"
                    strokeLinecap="round"
                />
            </svg>
        );
    };

    const CustomEyeClosed = () => {
        return (
            <svg width="28" height="28" viewBox="0 0 28 28" style={{ cursor: 'pointer' }}>
                {/* Closed eye line with curve */}
                <path
                    d="M 6 14 Q 14 18 22 14"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                    // strokeLinecap="round"
                />
            </svg>
        );
    };

    const [isTyping, setIsTyping] = useState(false);
    const passwordFieldRef = useRef(null);
    const typingTimeoutRef = useRef(null);

    const handlePasswordChange = (e) => {
        // Update the field value
        const value = e.target.value;

        // Set typing state
        setIsTyping(true);

        // Clear existing timeout
        if (typingTimeoutRef.current) {
            clearTimeout(typingTimeoutRef.current);
        }

        // Set timeout to reset typing state after user stops typing
        typingTimeoutRef.current = setTimeout(() => {
            setIsTyping(false);
        }, 1000); // 1 second after user stops typing
    };



    return (
        <Box className="screencontainer">
            <motion.div
                initial={{ x: 450 }}
                animate={{ x: 100 }}
                transition={{ duration: 1.7 }}
            >
                <Grid2>
                    <img src={ORLogo} alt="Logo" style={{ width: "50%", height: '50%' }} draggable={false}></img>
                </Grid2>

            </motion.div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid2 sx={{ display: 'flex' }}>
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 1, duration: 0.5 }}
                    >
                        <Grid2>
                            <Grid2 container item sx={{ display: "flex", flexDirection: "column", width: '410px' }} rowGap={2}>
                                <Grid2 sx={{ display: 'flex', flexDirection: 'column' }} rowGap={1}>
                                    <Typography sx={{ fontWeight: 600, fontSize: '28px', color: '#181D27' }}> Log In </Typography>
                                    <Typography variant="body2" sx={{ color: '#535862', fontSize: '12.5px' }}>Please Enter your Details</Typography>
                                </Grid2>
                                <Grid2 item>
                                    <InputLabel className="inputlabels">Email</InputLabel>
                                    <Controller
                                        control={control}
                                        name={"email"}
                                        render={({ field }) => (
                                            <TextField
                                                {...register("email")}
                                                {...field}
                                                size="small"
                                                placeholder="Enter your email"
                                                className="mailtextfield"
                                                sx={{
                                                    "& .MuiFormHelperText-root": {
                                                        color: "red",
                                                    }
                                                }}
                                            />
                                        )}
                                    />
                                    {errors.email && (
                                        <FormHelperText sx={{ color: 'red', marginLeft: "15px" }}>
                                            {errors.email.message}
                                        </FormHelperText>
                                    )}
                                </Grid2>

                                <Grid2 item sx={{ display: "flex", flexDirection: "column" }}>
                                    <InputLabel className="inputlabels">Password</InputLabel>
                                    <FormControl size="small">
                                        <Controller
                                            control={control}
                                            name={"password"}
                                            render={({ field }) => (
                                                <OutlinedInput
                                                    {...register("password")}
                                                    {...field}
                                                    ref={passwordFieldRef}
                                                    onChange={(e) => {
                                                        field.onChange(e);
                                                        handlePasswordChange(e);
                                                    }}
                                                    sx={{ backgroundColor: "white", borderRadius: '10px' }}
                                                    placeholder='Enter your password'
                                                    type={showPassword ? 'text' : 'password'}
                                                    className="mailtextfield"
                                                    endAdornment={
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                aria-label={
                                                                    showPassword ? 'hide the password' : 'display the password'
                                                                }
                                                                onClick={handleClickShowPassword}
                                                                edge="end"
                                                            >
                                                                {showPassword ? (
                                                                    <CustomEyeOpen
                                                                        isTyping={isTyping}
                                                                        passwordFieldRef={passwordFieldRef}
                                                                    />
                                                                ) : (
                                                                    <CustomEyeClosed />
                                                                )}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    }
                                                />
                                            )}
                                        />
                                        {errors.password && (
                                            <FormHelperText sx={{ color: 'red' }}>
                                                {errors.password.message}
                                            </FormHelperText>
                                        )}
                                    </FormControl>
                                </Grid2>

                                <Grid2 sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Checkbox sx={{ '& .MuiSvgIcon-root': { fontSize: 18 }, padding: 0, marginRight: '3px' }} />
                                        <Typography sx={{ fontSize: '13px', color: '#414651' }}>Remember for 30 days</Typography>
                                    </Box>
                                    <Typography sx={{ color: '#6941C6', cursor: "pointer", fontWeight: 600, fontSize: '12px', textAlign: 'end' }} onClick={handleForgotPswdNav}>Forgot Password</Typography>
                                </Grid2>
                                <Button variant="contained" className="loginButton" type="submit"> Sign in </Button>
                            </Grid2>
                        </Grid2>
                        <Grid2 sx={{ width: '100%' }}>
                            <Typography className="text"><span style={{ color: "#6941C6", fontWeight: 600, fontSize: '12px' }}>--Or Sign in with--</span></Typography>
                        </Grid2>

                        <Grid2
                            sx={{
                                marginTop: "10px",
                                display: 'flex',
                                justifyContent: "center",
                                paddingBottom: "15px",
                            }}>
                            <GoogleOAuthProvider clientId='1082536633509-1b01halu3aosgt8huv5at3k4snjh4hrt.apps.googleusercontent.com'>
                                <GoogleLogin
                                    onSuccess={handleGoogleLoginSuccess}
                                    onFailure={handleGoogleLoginFailure}
                                    sx={{ width: '50' }}
                                    render={renderProps => (
                                        <Button
                                            onClick={renderProps.onClick}
                                            disabled={renderProps.disabled}
                                            variant="contained"
                                            className="googleButton"
                                        >
                                            <img
                                                src={GoogleIcon}
                                                alt="Google"
                                                style={{ width: 24, height: 24 }}
                                            />
                                            Sign in with Google
                                        </Button>
                                    )}
                                />
                            </GoogleOAuthProvider>
                        </Grid2>

                        <Grid2 sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: '1px solid #d3d3d3',
                                    borderRadius: '4px',
                                    padding: '8px 16px',
                                    cursor: 'pointer',
                                    backgroundColor: '#fff',
                                    '&:hover': {
                                        backgroundColor: '#f0f0f0'
                                    },
                                    display: 'inline-flex'
                                }}
                                onClick={handleMicroLogin}
                            >
                                <img src={Microsoft} alt="Microsoft" style={{ width: 24, height: 24 }} />
                                <Typography
                                    sx={{
                                        fontFamily: '"Segoe UI", "Roboto", "Helvetica Neue", sans-serif',
                                        fontWeight: 600,
                                        fontSize: '16px',
                                        marginLeft: 1,
                                        color: '#000'
                                    }}
                                >
                                    Continue with Microsoft
                                </Typography>
                            </Box>
                        </Grid2>
                        <Grid2 sx={{ width: '100%' }}>
                            <Typography className="text">Don't have an account? <span style={{ cursor: "pointer", color: "#6941C6", fontWeight: 600, fontSize: '12px' }} onClick={handleSignupNav}>Sign Up</span> </Typography>
                        </Grid2>

                    </motion.div>
                    {/* <Typography className="text" >Candidate? <span style={{ color: "#0073B1", cursor: "pointer" }} onClick={handleRegisterNav}>Register</span> </Typography> */}
                </Grid2>
            </form>
        </Box>
    )
}

export default Login